/** biome-ignore-all lint/correctness/useExhaustiveDependencies: <disable error-prone biome rule> */
import CircularProgress, { type CircularProgressProps } from '@mui/material/CircularProgress';
import Portal from '@mui/material/Portal';
import { css, styled } from '@mui/material/styles';
import { randomUUID } from '@openx/utils/lib/uuid.ts';
import { type JSX, useEffect } from 'react';
import { useLoaderContext } from './LoaderContext.tsx';

const StyledLoaderContainerDiv = styled('div')<{
  hasPadding: boolean;
  // when fullSize is true loader fills the whole page
  fullSize?: boolean;
}>`
  text-align: center;

  ${({ hasPadding, theme }) =>
    hasPadding &&
    css`
      padding: ${theme.spacing(4)};
    `}
`;

const StyledFullSizeLoaderBox = styled('div')`
  display: grid;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: absolute;
`;

export type LoaderProps = {
  noPadding?: boolean;
  fullSize?: boolean;
  'data-test'?: string;
} & CircularProgressProps;

export const Loader = (props: LoaderProps): JSX.Element => {
  const { registerLoader } = useLoaderContext();

  useEffect(() => registerLoader(randomUUID() as string), []);

  const { noPadding, fullSize, 'data-test': dataTest, ...restProps } = props;

  if (fullSize) {
    return (
      <Portal container={document.getElementById('root')}>
        <StyledFullSizeLoaderBox data-test={dataTest}>
          <CircularProgress color="primary" {...restProps} />
        </StyledFullSizeLoaderBox>
      </Portal>
    );
  }

  return (
    <StyledLoaderContainerDiv hasPadding={!noPadding} data-test={dataTest}>
      <CircularProgress color="primary" {...restProps} />
    </StyledLoaderContainerDiv>
  );
};
